import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {ANALYTICS_MODULE} from 'constants/AnalyticsConstants';
import getConfig from 'getConfig';
import {ActionOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import {
  CONTEXTUAL_TEMPLATE_EDITING_RELEASE_VALUE,
  CONTEXTUAL_TEMPLATE_EDITING_SUPPORTING_INFO,
  CONTEXTUAL_TEMPLATE_EDITING_TEXT,
} from 'notebook/entry-templates/TemplateConstants';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';
import Button, {ButtonStyle} from 'ui-library/buttons/Button';
import runModal from 'ui-library/runModal';

import ContextualTemplateEditingBetaModal from './ContextualTemplateEditingBetaModal';

function SupportingInfo(): JSX.Element {
  const onClickCallback = (): void => {
    runModal(ContextualTemplateEditingBetaModal, {
      releaseValue: CONTEXTUAL_TEMPLATE_EDITING_RELEASE_VALUE,
      analyticsMetadata: {
        actionOrigin: ActionOrigin.NOTEBOOK_TEMPLATE_COLLECTION_PAGE,
        modalType: 'contextual_template_editing',
      },
      analyticsModule: ANALYTICS_MODULE.ELN,
    });
  };

  return (
    <div className={css(styles.surround)}>
      <div className={css(styles.text)}>{CONTEXTUAL_TEMPLATE_EDITING_SUPPORTING_INFO}</div>
      <Button
        buttonStyle={ButtonStyle.LINK}
        text="Contact Customer Support"
        onClick={onClickCallback}
        className={css(styles.button)}
      />
    </div>
  );
}

export default function ContextualTemplateEditingInlineBanner(): JSX.Element | null {
  if (!getConfig('ENABLE_TEMPLATE_COLLECTIONS_IN_WORKSPACE_BETA_BANNER')) {
    return null;
  }
  return (
    <InlineBanner
      bannerType={InlineBannerType.BETA}
      hideIcon={true}
      text={CONTEXTUAL_TEMPLATE_EDITING_TEXT}
      supportingInfo={<SupportingInfo />}
    />
  );
}

const styles = StyleSheet.create({
  surround: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  text: {
    flex: '0 0 auto',
  },
  button: {
    flex: '0 0 auto',
    margin: '0px 4px',
  },
});
